import { ProductSlide } from '../../../../../models/slides/ProductSlide';

export const getProductSlide = (wineElement: ProductSlide[]) => {
  const updatedWine = {
    imgUrl: wineElement[0]?.imgUrl || '',
    type: 'PRODUCT',
    title: wineElement[0]?.title || '',
    description: wineElement[0]?.description || '',
    id: wineElement[0]?.id || 0,
    productVariantId: wineElement[0]?.productVariantId || 0,
    availableQuantity: wineElement[0]?.availableQuantity || 0,
    basePrice: wineElement[0]?.basePrice || 0,
    discount: wineElement[0]?.discount || 0,
    currentPrice: wineElement[0]?.currentPrice || 0,
    currentEurPrice: wineElement[0]?.currentEurPrice || 0,
    baseEurPrice: wineElement[0]?.baseEurPrice || 0,
    showEurPrice: wineElement[0]?.showEurPrice || false,
    isManufacturer: wineElement[0]?.isManufacturer || false,
    tags: wineElement[0]?.tags || [],
    productYear: wineElement[0]?.productYear || 0,
  };

  return updatedWine;
};
